export function getLinkCompatibleWithUrl(list = [], url) {
  const hasValueUrl = list.find(value => {
    const valuePathName = value.split('/')

    return `/${valuePathName[3]}/${valuePathName[4]}/` === url
  })

  return hasValueUrl
}
